import { apiUrl } from '.';
import { authService } from '.';

const getTeams = async () => {
    const requestOptions = {
        method: 'GET',
    };

    const res = await authService.handleResponse(apiUrl + '/volunteer/', requestOptions);
    return res;
}

const getContacts = async (filter) => {
    const requestOptions = {
        method: 'GET',
    };

    const res = await authService.handleResponse(apiUrl + '/volunteer/contacts?group='+filter.group+'&team='+filter.team+'&checkbox='+filter.checkbox, requestOptions);
    return res;
}

const getContactFilters = async (filter) => {
    const requestOptions = {
        method: 'GET',
    };

    const res = await authService.handleResponse(apiUrl + '/volunteer/contacts/filters', requestOptions);
    return res;
}

export const volunteerService = {
    getTeams,
    getContacts,
    getContactFilters
};